<script>
import { whereAmIClicked } from "./slider_utils.mjs";
export default {
  methods: {},
  props: {
    steps: Array,
    initIndex: {
      default: 3,
      type: Number,
    },
    step: Object,
    accent: String,
    animated: Boolean,
  },
  data: function () {
    return {
      stepIndex: 0,
      stepWidth: 0,
      mouseDown: false,
      size: 32,
    };
  },
  computed: {
    cssVars() {
      return {
        "--cursorLeft": Math.floor(this.stepIndex * this.stepWidth + 16) + "px",
        "--fillWidth": Math.floor(this.stepIndex * this.stepWidth + 16) + "px",
      };
    },
    value() {
      return this.steps[this.stepIndex];
    },
    sliderElt() {
      return this.$refs.sliderElt;
    },
  },
  mounted: function () {
    this.stepIndex = this.initIndex;
    window.addEventListener("mousemove", this.mousemove);
    // window.addEventListener("mousedown", this.mousedown);
    window.addEventListener("mouseup", this.mouseup);
  },
  beforeDestroy: function () {
    window.removeEventListener("mousemove", this.mousemove);
    // window.removeEventListener("mousedown", this.mousedown);
    window.removeEventListener("mouseup", this.mouseup);
  },
  methods: {
    mousemove: function ($event) {
      if (!this.mouseDown && $event.type != "click") return;

      const x = whereAmIClicked(this.sliderElt, $event);
      const progress = x / this.sliderWidth;

      this.stepIndex = Math.round(progress * (this.steps.length - 1));
      // this.value = this.steps[this.stepIndex];

      this.$emit("new:value", this.value);
      this.$emit("update:step", this.value);
    },
    mousedown: function ($event) {
      this.sliderWidth = this.sliderElt.getBoundingClientRect().width;
      this.mouseDown = true;
    },
    mouseup: function ($event) {
      this.mouseDown = false;
    },
    onMouseupOutside: function ($event) {
      this.mouseDown = false;
    },
    calculateStepWith() {
      const width =
        this.$el.getElementsByClassName("f-slider-heavy")[0].offsetWidth;

      this.stepWidth = (width - this.size) / (this.steps.length - 1);
    },
  },
  watch: {
    step(newStep) {
      const index = this.steps.findIndex((step) => step === newStep);
      this.stepIndex = index >= 0 ? index : this.initIndex;
    },
    index() {
      this.stepIndex = this.index;
    },
    stepIndex() {
      this.calculateStepWith();
    },
  },
};
</script>
    
<template>
  <div
    class="f-slider-heavy-container"
    :class="{ animated }"
    v-resize
    @resize="calculateStepWith()"
  >
    <div
      class="f-slider-heavy"
      ref="containerElt"
      @click="mousemove($event)"
      @mousedown="mousedown($event)"
      :style="cssVars"
      v-mouseup-outside="onMouseupOutside"
    >
      <div class="f-container" ref="sliderElt">
        <div class="f-background"></div>
        <div class="f-fill"></div>
        <div class="f-cursor" :class="{ 'mouse-down': mouseDown }">
          <div class="point"></div>
          <div class="popup"><slot></slot></div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
.f-slider-heavy-container {
  $colorTemplate: hsl(177, 41%, 55%);
  --fillColor-h: 177;
  --fillColor-s: 41%;
  --fillColor-l: 55%;

  
  user-select: none;

  &.animated {
    .f-fill {
      transition-property: background-color, width !important;
    }
    .f-cursor {
      transition-property: background-color, left !important;
    }
  }

  // colors
  .f-background {
    background-color: var(--blue-a5);
    &:hover {
      background-color: var(--blue-a10);
    }
    &:active {
      background-color: var(--blue-a25);
    }
  }
  .f-fill {
    background-color: var(--turquoise);
    &:hover {
      background-color: var(--turquoise-d90);
    }
    &:active {
      background-color: var(--turquoise-d80);
    }
  }
  .f-cursor {
    &:hover::after {
      background-color: var(--blue-a25);
    }
    &:active::after {
      background-color: var(--blue-a75);
    }
  }

  &.warning {
    .f-background {
      background-color: var(--blue-a5);
      &:hover {
        background-color: var(--blue-a10);
      }
      &:active {
        background-color: var(--blue-a25);
      }
    }
    .f-fill {
      background-color: var(--statusNotice);
      &:hover {
        background-color: var(--statusNotice-d90);
      }
      &:active {
        background-color: var(--statusNotice-d80);
      }
    }
    .f-cursor {
      &:hover::after {
        background-color: var(--blue-a25);
      }
      &:active::after,
      &.mouse-down::after {
        background-color: var(--blue-a75);
      }
    }
  }

  $size: 32px;
  $halfSize: 16px;
  $animationTiming: 125ms;

  user-select: none;

  display: flex;
  .f-slider-heavy {
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    height: 48px;
    cursor: pointer;
    .f-container {
      position: relative;
      flex: 1 1 100%;
      height: $size;

      > * {
        transition: background-color $animationTiming ease;
      }
      // background-color: rgba(24, 144, 211, 0.05);
      // border-radius: $halfSize;

      .f-background {
        border-radius: $halfSize;
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .f-fill {
        position: absolute;
        width: calc(var(--cursorLeft) + #{$halfSize});
        height: 100%;
        border-radius: $halfSize;
      }

      .f-cursor {
        position: absolute;
        $size: $size;
        width: $size;
        height: $size;
        background-color: transparent;

        left: var(--cursorLeft);

        border-radius: $halfSize;

        // pointer-events: none;
        top: 0;
        margin-left: -$halfSize;
        > .point {
          position: absolute;
          width: 24px;
          height: 24px;
          box-shadow: 0px 4px $halfSize rgba(22, 22, 21, 0.25);
          border-radius: $halfSize;
          top: 4px;
          left: 4px;

          background-color: white;

          pointer-events: none;
        }

        > .popup {
          --size: 400px;

          position: absolute;
          width: var(--size);
          height: 200px;
          background-color: transparent;
          // color: white;
          // background-color: pink;
          margin-left: calc(-0.5 * var(--size));
          left: 50%;
          bottom: 38px;

          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: flex-end;
        }
      }
    }
    .f-container {
      .f-cursor::after {
        content: "";
        display: block;
        height: 12px;
        width: 12px;
        border-radius: $halfSize;
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
  }

  .f-stepper {
    display: flex;
    align-items: center;
    border: 1px solid #bbbbb8;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 12px;
    margin-left: $halfSize;
    width: 80px;
    flex: 0 0 80px;

    .f-stepper-actions {
      display: flex;
      flex-direction: column;
      margin-left: auto;
    }
  }
}
</style>